
export const parseTranslations = (data) => {
  if (data.length && typeof data != 'string') {
    data = parseArray(data);
  } else if (typeof data === 'object') {
    data = parseObject(data);
  }

  return data;
}

function parseArray (data) {

  for (var item of data) {
    item = parseTranslations(item);
  }

  return data;
}

function parseObject (data) {
  if (data.translations) {
    if (typeof data.translations === 'string') {
      data.translations = JSON.parse(data.translations);
    }

    var locale = window.app.$store.getters['user/data'].language;
    // locale = 'jp';

    if (data.name) {
      data.name = data.translations[locale];
    }
    if (data.Name) {
      data.Name = data.translations[locale];
    }
  }

  if (data.data && typeof data.data !== 'string') {
    data.data = parseTranslations(data.data);
  }
  if (data.varieties) {
    data.varieties = parseTranslations(data.varieties);
  }
  if (data.methods) {
    data.methods = parseTranslations(data.methods);
  }
  if (data.goals) {
    data.goals = parseTranslations(data.goals);
  }
  if (data.stages) {
    data.stages = parseTranslations(data.stages);
  }

  return data;
}
